import React from 'react';

interface ThumbsUpFilledIconProps {
  className?: string;
  fill?: string;
}

export default function ThumbsUpFilledIcon({ className, fill = 'currentColor' }: ThumbsUpFilledIconProps) {
  return (
    <svg
      width="30"
      height="31"
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M26.1758 8.38672C25.9097 8.0903 25.5846 7.85275 25.2214 7.68929C24.8581 7.52583 24.4647 7.44007 24.0664 7.4375H17.75V5.5625C17.7469 4.32025 17.2521 3.12976 16.3736 2.25135C15.4952 1.37295 14.3048 0.878094 13.0625 0.875C12.8883 0.876413 12.7178 0.925134 12.5692 1.01596C12.4206 1.10678 12.2995 1.23628 12.2188 1.39062L7.78906 10.25H2.75C2.25272 10.25 1.77581 10.4475 1.42417 10.7992C1.07254 11.1508 0.875 11.6277 0.875 12.125V22.4375C0.875 22.9348 1.07254 23.4117 1.42417 23.7633C1.77581 24.115 2.25272 24.3125 2.75 24.3125H22.6602C23.3442 24.3097 24.0041 24.0586 24.517 23.606C25.03 23.1534 25.3612 22.53 25.4492 21.8516L26.8555 10.6016C26.9023 10.2054 26.866 9.80388 26.7489 9.42254C26.6319 9.0412 26.4367 8.68843 26.1758 8.38672ZM2.75 12.125H7.4375V22.4375H2.75V12.125Z"
        fill={fill}
      />
    </svg>
  );
}
